import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "schedule-training" }
const _hoisted_2 = { class: "split-container" }
const _hoisted_3 = { class: "events-list" }
const _hoisted_4 = { class: "calendar-container" }
const _hoisted_5 = { class: "selectors" }
const _hoisted_6 = { class: "option" }
const _hoisted_7 = { class: "option" }
const _hoisted_8 = { class: "header-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode($setup["PendingRequests"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode($setup["Calendar"], {
          "selected-date": $setup.selectedDate,
          "onUpdate:selectedDate": _cache[3] || (_cache[3] = ($event: any) => (($setup.selectedDate) = $event)),
          "event-list": $setup.userEvents,
          "sort-category": $setup.sort,
          display: $setup.display
        }, {
          "header-left": _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[7] || (_cache[7] = _createElementVNode("label", null, "View", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.display) = $event))
                }, _cache[6] || (_cache[6] = [
                  _createElementVNode("option", { value: "month" }, "Month", -1),
                  _createElementVNode("option", { value: "week" }, "Week", -1),
                  _createElementVNode("option", { value: "day" }, "Day", -1)
                ]), 512), [
                  [_vModelSelect, $setup.display]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[9] || (_cache[9] = _createElementVNode("label", null, "Sort by", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.sort) = $event))
                }, _cache[8] || (_cache[8] = [
                  _createElementVNode("option", { value: "time" }, "Time", -1),
                  _createElementVNode("option", { value: "trainer" }, "Trainer", -1),
                  _createElementVNode("option", { value: "kennel" }, "Kennel", -1)
                ]), 512), [
                  [_vModelSelect, $setup.sort]
                ])
              ])
            ])
          ]),
          "header-right": _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "bottom-button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.openManageCalendarModal()))
              }, "Manage Calendars")
            ])
          ]),
          _: 1
        }, 8, ["selected-date", "event-list", "sort-category", "display"])
      ])
    ]),
    ($setup.selectedEvent)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(), _createBlock(_Teleport, { to: "body" })),
          _createVNode($setup["EventModal"], {
            "selected-event": $setup.selectedEvent,
            onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.selectedEvent=null))
          }, null, 8, ["selected-event"])
        ], 64))
      : _createCommentVNode("", true),
    ($setup.showCalendarModal)
      ? (_openBlock(), _createBlock($setup["Modal"], {
          key: 1,
          onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.showCalendarModal = false))
        }, {
          default: _withCtx(() => [
            _createVNode($setup["ManageCalendarsModal"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    ($setup.showAlert)
      ? (_openBlock(), _createBlock($setup["Alert"], {
          key: 2,
          "main-calendar": $setup.calendarStore.main
        }, null, 8, ["main-calendar"]))
      : _createCommentVNode("", true)
  ]))
}